"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _TranslateAware = _interopRequireDefault(require("../TranslateAware/TranslateAware"));

var _LanguageSelector = require("../Fields/LanguageSelector");

var _RemoteComboBox = _interopRequireDefault(require("../Fields/RemoteComboBox"));

var _antd = require("antd");

var _selectors = require("../../store/partnerEmulation/selectors");

var _selectors2 = require("../../store/user/selectors");

var _actions = require("../../store/auth/actions");

var _actions2 = require("../../store/partnerEmulation/actions");

var _filters = require("../../constants/filters");

var _FilterForm = require("../FilterForm");

var _ColumnFilter = require("../FilterForm/ColumnFilter");

var _columnFilter = require("../../constants/columnFilter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Header =
/*#__PURE__*/
function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Header)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleUserMenuClick", function (item, key) {
      var dispatch = _this.props.dispatch;

      if (item.key === "logout") {
        dispatch((0, _actions.unauthorizeSaga)());
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterFieldChange", function (partnerId) {
      var _this$props = _this.props,
          partnerEmulationOn = _this$props.partnerEmulationOn,
          partnerEmulationOff = _this$props.partnerEmulationOff;

      if (!partnerId) {
        partnerEmulationOff();
      } else {
        partnerEmulationOn(partnerId);
      }
    });

    return _this;
  }

  _createClass(Header, [{
    key: "sidebarToggle",
    value: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  }, {
    key: "mobileSidebarToggle",
    value: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          user = _this$props2.user,
          emulationPartnerId = _this$props2.emulationPartnerId,
          isAdmin = _this$props2.isAdmin;

      var userMenu = _react["default"].createElement(_antd.Menu, {
        onClick: this.handleUserMenuClick
      }, _react["default"].createElement(_antd.Menu.Item, {
        key: "logout"
      }, _react["default"].createElement(_antd.Icon, {
        type: "lock",
        style: {
          fontSize: 16
        }
      }), this.props.translate("header/logout")));

      return _react["default"].createElement("header", {
        className: "app-header navbar"
      }, _react["default"].createElement("a", {
        className: "navbar-brand",
        href: "/"
      }, "\xA0"), _react["default"].createElement("ul", {
        className: "nav navbar-nav d-md-down-none"
      }, _react["default"].createElement("li", {
        className: "nav-item"
      }, _react["default"].createElement("button", {
        className: "nav-link navbar-toggler sidebar-toggler",
        type: "button",
        onClick: this.sidebarToggle
      }, "\u2630"))), _react["default"].createElement("button", {
        className: "navbar-toggler mobile-sidebar-toggler d-lg-none",
        type: "button",
        onClick: this.mobileSidebarToggle
      }, "\u2630"), isAdmin && _react["default"].createElement("div", {
        className: "global-partner-filter-wrp"
      }, _react["default"].createElement(_FilterForm.FilterForm, {
        filterType: _filters.FILTER_TYPE.HEADER_FILTER
      }, _react["default"].createElement(_ColumnFilter.ColumnFilter, {
        title: 'header/partnerToEmulate',
        fieldName: _filters.FILTER_FIELD.PARTNER_EMULATION_ID,
        optionsSource: {
          url: _filters.FILTER_URLS.PARTNER_URL
        },
        allowClear: true,
        showSearch: true,
        showArrow: true,
        mode: _columnFilter.FILTER_MODE_TYPE.SINGLE,
        style: {
          width: '100%'
        },
        onChange: this.onFilterFieldChange
      }))), _react["default"].createElement("ul", {
        className: "nav navbar-nav ml-auto"
      }, _react["default"].createElement("li", {
        className: "nav-item"
      }, _react["default"].createElement(_LanguageSelector.LanguageSelector, null)), _react["default"].createElement("li", {
        className: "nav-item"
      }, user.name && _react["default"].createElement(_antd.Dropdown, {
        overlay: userMenu,
        placement: "bottomRight",
        trigger: ['click']
      }, _react["default"].createElement(_antd.Button, null, _react["default"].createElement(_antd.Icon, {
        type: "user"
      }), _react["default"].createElement("span", {
        className: "header-button-title"
      }, [user.name, user.surname].join(' ')))))));
    }
  }]);

  return Header;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: (0, _selectors2.getUser)(state),
    isAdmin: (0, _selectors2.getIsAdmin)(state),
    emulationPartnerId: (0, _selectors.getEmulationPartnerId)(state)
  };
};

var mapDispatchToProps = {
  partnerEmulationOn: _actions2.enable,
  partnerEmulationOff: _actions2.disable
};

var _default = (0, _TranslateAware["default"])((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Header));

exports["default"] = _default;